import { render, staticRenderFns } from "./StoreLogo.vue?vue&type=template&id=20b21722&scoped=true"
import script from "./StoreLogo.vue?vue&type=script&lang=js"
export * from "./StoreLogo.vue?vue&type=script&lang=js"
import style0 from "./StoreLogo.vue?vue&type=style&index=0&id=20b21722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b21722",
  null
  
)

export default component.exports